// Constants
import { TaskChartMetric } from "@ms/uno-constants/lib/local/ChartConstants";
import { TaskStatus } from "../service/planner/enumerations/IPlannerEnumerations";
// Utilities
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
/**
 * Get the metric to be tracked against a task in chart views
 * @param task The task
 */ export function getTaskChartMetric(task) {
    // If the task is late, it takes precedence over status
    if (task.isLate()) {
        return TaskChartMetric.Late;
    }
    // Otherwise, map status to chart metric
    switch(task.status){
        case TaskStatus.NotStarted:
            return TaskChartMetric.NotStarted;
        case TaskStatus.InProgress:
            return TaskChartMetric.InProgress;
        case TaskStatus.Completed:
            return TaskChartMetric.Completed;
        default:
            ErrorUtilities.unreachableCase(task.status, ()=>{});
            return TaskChartMetric.NotStarted;
    }
}
